import { Link, NavLink, useLocation } from "react-router-dom";
import MuteToggle from "@/components/MuteToggle";
import UserMenu from "@/components/UserMenu";

export default function NavBar() {
  const { pathname } = useLocation();
  const linkCls = ({ isActive }) =>
    `text-[0.72rem] uppercase tracking-[0.28em] transition-colors duration-300 ${
      isActive ? "text-[#EAB308]" : "text-white/70 hover:text-[#EAB308]"
    }`;

  return (
    <header
      className="fixed top-0 left-0 right-0 z-40 rts-glass"
      data-testid="site-navbar"
    >
      <nav className="max-w-7xl mx-auto flex items-center justify-between px-6 md:px-10 py-4">
        <Link
          to="/"
          className="flex items-center gap-3 group"
          data-testid="nav-logo"
        >
          <span
            className="w-2 h-2 rounded-full bg-[#EAB308] group-hover:shadow-[0_0_14px_#EAB308] transition-shadow duration-300"
            aria-hidden="true"
          />
          <span className="font-serif-rts text-lg md:text-xl tracking-wide text-white">
            Road to <span className="text-[#EAB308]">Salvation</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <NavLink to="/" end className={linkCls} data-testid="nav-home">
            Home
          </NavLink>
          <NavLink to="/game" className={linkCls} data-testid="nav-game">
            Play
          </NavLink>
          <NavLink
            to="/prayer-line"
            className={linkCls}
            data-testid="nav-prayer-line"
          >
            Prayer Line
          </NavLink>
        </div>

        <div className="flex items-center gap-3">
          <MuteToggle />
          <UserMenu />
          <Link
            to="/prayer-line"
            className="rts-btn-primary !py-2 !px-4 text-[0.7rem]"
            data-testid="nav-cta-prayer"
          >
            Need Prayer?
          </Link>
        </div>
      </nav>
      {/* mobile bottom row */}
      <div className="md:hidden flex items-center justify-center gap-6 pb-3">
        <NavLink to="/" end className={linkCls} data-testid="nav-home-mobile">
          Home
        </NavLink>
        <NavLink to="/game" className={linkCls} data-testid="nav-game-mobile">
          Play
        </NavLink>
        <NavLink
          to="/prayer-line"
          className={linkCls}
          data-testid="nav-prayer-line-mobile"
        >
          Prayer Line
        </NavLink>
      </div>
      <span aria-hidden="true" className="sr-only">
        {pathname}
      </span>
    </header>
  );
}
